export default __webpack_public_path__ + "static/media/website_icon.c6bea237.svg";